import React from "react";

export default function Conditional({show, children}) {
  if (show !== true) return null;
  return children;
}

Conditional.defaultProps = {
  show: true
}